import Vue from 'vue';
import GeLink from './ge-link';

// Main component
Vue.component('ge-link', GeLink);

export default GeLink;



// WEBPACK FOOTER //
// ./scripts/ge-link/index.js